{
  "actions": {
    "add": "Ajouter",
    "apply": "Appliquer",
    "back": "Retour",
    "cancel": "Annuler",
    "clear": "Effacer",
    "close": "Fermer",
    "confirm": "Confirmer",
    "continue": "Continuer",
    "copy": "Copier",
    "create": "Créer",
    "delete": "Supprimer",
    "done": "Terminé",
    "download": "Télécharger",
    "duplicate": "Dupliquer",
    "edit": "Modifier",
    "open": "Ouvrir",
    "reload": "Recharger",
    "remove": "Retirer",
    "rename": "Renommer",
    "reset": "Réinitialiser",
    "retry": "Réessayer",
    "save": "Enregistrer",
    "search": "Rechercher",
    "send": "Envoyer",
    "tryAgain": "Réessayer",
    "undo": "Annuler",
    "upload": "Importer"
  },
  "status": {
    "loading": "Chargement…",
    "saving": "Enregistrement…",
    "saved": "Enregistré",
    "copied": "Copié",
    "deleting": "Suppression…",
    "uploading": "Import en cours…"
  },
  "labels": {
    "untitled": "Sans titre",
    "noTitle": "Sans titre",
    "none": "Aucun",
    "name": "Nom",
    "email": "E-mail",
    "search": "Rechercher",
    "settings": "Réglages",
    "language": "Langue"
  },
  "errors": {
    "generic": "Une erreur est survenue",
    "network": "Problème de connexion. Vérifiez votre réseau et réessayez."
  }
}
